import Isotope from 'isotope-layout';

class MasonryGallery {
    constructor() {
        if (document.querySelector('.masonry-gallery') == null) {
            return false;
        }

        if (window.innerWidth < 428.98) {
            return false;
        }

        this.iso = new Isotope('.masonry-gallery', {
            itemSelector: '.grid-item',
            masonry: {
                columnWidth: '.grid-sizer'
            }
        })

        document.querySelector('.masonry-gallery').parentElement.style.overflow = 'hidden';
    }
}

export default MasonryGallery